import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form, Modal, notification } from "antd";

import { POST } from "../../../../providers/useAxiosQuery";
import validateRules from "../../../../providers/validateRules";
import notificationErrors from "../../../../providers/notificationErrors";
import FloatQuill from "../../../../providers/FloatQuill";
import FloatSelect from "../../../../providers/FloatSelect";

export default function ModalFormQuestionCategory(props) {
	const {
		toggleModalQuestionCategory,
		setToggleModalQuestionCategory,
		form_id,
		dataFormQuestionCategory,
	} = props;
	const navigate = useNavigate();

	const [form] = Form.useForm();

	const { mutate: mutateForm, isLoading: isLoadingForm } = POST(
		"api/form_question_category",
		"form_question_category"
	);

	const onFinish = (values) => {
		console.log("values: ", values);

		let data = {
			...values,
			form_id: form_id,
			id: toggleModalQuestionCategory.data
				? toggleModalQuestionCategory.data.id
				: "",
		};
		mutateForm(data, {
			onSuccess: (res) => {
				if (res.success) {
					notification.success({
						message: "Question Category",
						description: res.message,
					});
					if (
						toggleModalQuestionCategory.data &&
						toggleModalQuestionCategory.data.id
					) {
						setToggleModalQuestionCategory({
							open: false,
							data: null,
						});
					} else {
						navigate(
							`/evaluation/view/${form_id}/category/edit/${res.data.id}`
						);
					}
				} else {
					notification.error({
						message: "Question Category",
						description: res.message,
					});
				}
			},
			onError: (err) => {
				notificationErrors(err);
			},
		});
	};

	useEffect(() => {
		if (toggleModalQuestionCategory.open) {
			if (toggleModalQuestionCategory.data) {
				form.setFieldsValue(toggleModalQuestionCategory.data);
			}
		}

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toggleModalQuestionCategory]);

	return (
		<Modal
			closeIcon={<FontAwesomeIcon icon={faTimes} />}
			title="Question Category Form"
			open={toggleModalQuestionCategory.open}
			footer={null}
			onCancel={() =>
				setToggleModalQuestionCategory({
					open: false,
					data: null,
				})
			}
			forceRender
		>
			<Form form={form} onFinish={onFinish}>
				<Form.Item name="category" rules={[validateRules.required()]}>
					<FloatQuill
						label="Question Category"
						placeholder="Question Category"
						required
					/>
				</Form.Item>
				<Form.Item name="parent_category_id">
					<FloatSelect
						label="Question Category"
						placeholder="Question Category"
						options={
							dataFormQuestionCategory && dataFormQuestionCategory.length > 0
								? dataFormQuestionCategory.map((item) => {
										return {
											label: item.category,
											value: item.id,
										};
								  })
								: []
						}
					/>
				</Form.Item>

				<Button
					htmlType="submit"
					className="btn-main-primary"
					loading={isLoadingForm}
				>
					SUBMIT
				</Button>
			</Form>
		</Modal>
	);
}
